import PropTypes from 'prop-types';
import React from 'react';

// styles
import css from './rating.sss';

const MAX_RATING = 5;

export const Rating = ({ rating }) => {
    const ratingPercents = Math.round(rating / MAX_RATING * 100);

    return (
        <div className={css.root}>
            <div className={css.stars}>
                <span className={css.progress}>
                    <span
                        className={css.bar}
                        style={{ width: `${ratingPercents}%` }}
                    />
                    <span className={css.mask} />
                </span>
            </div>
        </div>
    );
};

Rating.propTypes = {
    rating: PropTypes.number,
};
